const skillData = [
    {
        id: 0,
        src: "https://img.icons8.com/color/452/mongodb.png"
    },
    {
        id: 1,
        src: "https://uxwing.com/wp-content/themes/uxwing/download/10-brands-and-social-media/expressjs.svg"
    },
    {
        id: 2,
        src: "https://cdn.icon-icons.com/icons2/2415/PNG/128/react_original_wordmark_logo_icon_146375.png"
    },
    {
        id: 3,
        src: "https://cdn.icon-icons.com/icons2/2415/PNG/128/nodejs_original_wordmark_logo_icon_146412.png"
    },
    {
        id: 4,
        src: "https://img.icons8.com/color/2x/javascript.png"
    },
    {
        id: 5,
        src: "https://img.icons8.com/fluency/344/python.png"
    },
    {
        id: 6,
        src: "https://img.icons8.com/external-soft-fill-juicy-fish/2x/external-sql-coding-and-development-soft-fill-soft-fill-juicy-fish.png"
    },
    {
        id: 7,
        src: "https://img.icons8.com/color/344/docker.png"
    }
]

export default skillData